export default "__VITE_ASSET__BsGTNXwX__"